import { useQueryClient } from '@tanstack/react-query';
import useMutationApi from 'src/api/useMutationApi';
import { CoreEnumResponse } from './useCreateCoreEnum';

export interface UpdateCoreEnumData {
  name?: string;
  description?: string;
  isSystem?: boolean; // Only admins can toggle this
  areOptionsLocked?: boolean;
  options?: Array<{
    id?: string;
    name: string;
    description?: string;
    sortOrder: number;
  }>;
}

const useUpdateCoreEnum = (enumId: string, onSuccess?: () => void) => {
  const queryClient = useQueryClient();

  return useMutationApi<UpdateCoreEnumData, CoreEnumResponse>({
    endpoint: `core/core-enums/${enumId}`,
    method: 'PUT',
    successMessage: 'Enum updated successfully',
    errorMessage: 'Failed to update enum',
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['core/core-enums'] });
        onSuccess?.();
      },
    },
  });
};

export default useUpdateCoreEnum;
